import React, { SyntheticEvent } from 'react'

// import RangeSlider from './RangeSlider'
import { FilterProps, FiltersProps } from '../../shared/Module'

interface FacetComponentProps {
  activeFilters: FiltersProps
  filters: FiltersProps
  disabled: boolean
  id: string
  onFilterDelete: Function
  onFilterSelect: Function
  prefix?: string
  title: string
}
const Facet = ({
  activeFilters = [],
  disabled,
  filters,
  id,
  onFilterDelete,
  onFilterSelect,
  prefix = '',
  title,
}: FacetComponentProps) => {
  return (
    <fieldset className='c-filter__category'>
      <legend className='c-filter__legend'>{title}</legend>

      {filters.map(({ label, value }) => (
        <React.Fragment key={`${id}-${value}`}>
          <input
            checked={isFilterActive(value)}
            disabled={disabled}
            id={`${prefix}-${id}-${value}`}
            onChange={() => handleFilter({ label, value })}
            type='checkbox'
          />
          <label
            className='c-label c-label--checkbox'
            htmlFor={`${prefix}-${id}-${value}`}
          >
            {label}
          </label>
        </React.Fragment>
      ))}
    </fieldset>
  )

  // Manage filter selection or removal
  function handleFilter(filter: FilterProps) {
    if (isFilterActive(filter.value)) {
      onFilterDelete({ ...filter, id })
    } else {
      onFilterSelect({ ...filter, id })
    }
  }

  // Check if the given filter is active
  function isFilterActive(filterValue: string | number) {
    return activeFilters.some(({ value }) => value === filterValue)
  }
}

export default Facet
